import * as yup from 'yup'

export const EmailValidationSchema = yup.object().shape({
  email: yup.string().email("1:Invalid email").required("1:Email is required"),
})